import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ClientesService } from "app/core/services/clientes/clientes.service";
import { columnHeader } from "app/shared/factoring-datatable/factoring-datatable.component";
import { ConfirmModalComponent } from "app/shared/utils/confirm-modal/confirm-modal.component";
import { AddOtherCreditComponent } from "app/modules/clientes/modals/add-other-credit/add-other-credit.component";

@Component({
  selector: "app-antecedentes-credito-otros-creditos",
  templateUrl: "./otros-creditos.component.html",
  styleUrls: ["./otros-creditos.component.css"],
})
export class OtrosCreditosComponent implements OnInit {
  public rowData: any[] = [];
  public loadingTable: boolean = false;
  public columnDefs: columnHeader[];
  public pageTableActual: number;
  public pageTableTotal: number;
  public pageTablePerPages: number = 10;
  public pageTablePages: number[];
  public searchstring: string = "";
  public moneda_deuda: number = 2;

  @Input() clienteId = 0;
  @Input() readonly = false;

  constructor(
    private clientesService: ClientesService,
    public modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.obtenerOtrosCreditos();
  }

  obtenerOtrosCreditos(page = 1, page_size = 10) {
    this.clientesService
      .obtenerOtrosCreditos(this.clienteId.toString(), page, page_size)
      .then((res) => {
        this.initVars();
        this.loadTable(res);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  loadTable(data) {
    this.rowData = data.results.map((el: any, i: number) => ({
      ...el,
      index: i + 1,
    }));
    this.pageTableActual = data.page_number;
    this.pageTableTotal = data.count;
    this.pageTablePerPages = data.per_page;
    this.pageTablePages = [];
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index);
    }
  }

  initVars() {
    let columns = [
      {
        headerName: "N°",
        field: "index",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Tipo de Crédito",
        field: "tipo_credito_nombre",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Entidad Financiera",
        field: "entidad_financiera_nombre",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Moneda",
        field: "moneda_descripcion",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Nro de Cuotas",
        field: "plazo",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Monto de Cuota",
        field: "monto",
        sortable: true,
        pipe: "currency",
        moneda: "moneda",
      },
      {
        class: "text-center",
        headerName: "Vencimiento Primera Cuota",
        field: "vencimiento_primera_cuota",
        sortable: true,
        pipe: "date",
      },
      {
        class: "text-center",
        headerName: "Vencimiento Última Cuota",
        field: "vencimiento_primera_cuota",
        sortable: true,
        pipe: "date",
      },
      {
        class: "text-center",
        headerName: "Cuotas Pagadas",
        field: "cuotas_pagadas",
        sortable: true,
      },
    ];

    this.columnDefs = columns;
  }

  goToPage({ page, per_page, filtros }) {
    this.obtenerOtrosCreditos(page, per_page);
  }

  tableEditEvent(credit) {
    const modalRef = this.modalService.open(AddOtherCreditComponent, {
      size: "lg",
    });

    modalRef.componentInstance.clienteId = this.clienteId;
    modalRef.componentInstance.creditId = credit.id;

    modalRef.componentInstance.successEmit.subscribe(
      (result) => {
        this.obtenerOtrosCreditos();
      },
      (error) => {}
    );
  }

  destroyContact(credit) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {});

    modalRef.componentInstance.title = "Remover Crédito";
    modalRef.componentInstance.message =
      "¿Seguro que desea remover el crédito?";

    modalRef.result.then((result) => {
      if (result) {
        this.clientesService
          .eliminarOtroCredito(credit.id)
          .then((result) => {
            this.obtenerOtrosCreditos();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  openModal() {
    const modalRef = this.modalService.open(AddOtherCreditComponent, {
      size: "lg",
    });

    modalRef.componentInstance.clienteId = this.clienteId;

    modalRef.componentInstance.successEmit.subscribe(
      (result) => {
        this.obtenerOtrosCreditos();
      },
      (error) => {}
    );
  }
}
